import segmentProps from '../../lib/segmentProps';

/**
 * Data that comes from the event reducer at this point in time
 * {
 *   "gas": {
 *     "supplierId": "39",
 *     "tariffId": "44",
 *     "unknownTariff": true,
 *     "paymentMethod": "Monthly Direct Debit",
 *     "units": "spend",
 *     "usage": {
 *       "spend": {
 *         "timePeriod": "Year",
 *         "cost": 2342134
 *       }
 *     }
 *   },
 *   "electric": {
 *     "supplierId": "59",
 *     "tariffId": "301",
 *     "unknownTariff": true,
 *     "paymentMethod": "Monthly Direct Debit",
 *     "units": "actual",
 *     "usage": {
 *       "actual": {
 *         "timePeriod": "Year",
 *         "kwh": 1241241
 *       }
 *     }
 *   }
 * }
 */
const props = {
    switch_id: '?@entities.energySwitches.current.id',
    ofg_supplier_id: '?@events.gas.supplierId',
    ofg_tariff_id: '?@events.gas.tariffId',
    ofg_unknown_tariff: '?@events.gas.unknownTariff',
    ofg_payment_method: '?@events.gas.paymentMethod',
    ofg_units: '?@events.gas.units',
    ofg_usage_estimate: '?@events.gas.usage.estimate',
    ofg_usage_spend_time_period: '?@events.gas.usage.spend.timePeriod',
    ofg_usage_spend_cost: '?@events.gas.usage.spend.cost',
    ofg_usage_actual_time_period: '?@events.gas.usage.actual.timePeriod',
    ofg_usage_actual_kwh: '?@events.gas.usage.actual.kwh',
    ofe_supplier_id: '?@events.electric.supplierId',
    ofe_tariff_id: '?@events.electric.tariffId',
    ofe_unknown_tariff: '?@events.electric.unknownTariff',
    ofe_payment_method: '?@events.electric.paymentMethod',
    ofe_units: '?@events.electric.units',
    ofe_usage_estimate: '?@events.electric.usage.estimate',
    ofe_usage_spend_time_period: '?@events.electric.usage.spend.timePeriod',
    ofe_usage_spend_cost: '?@events.electric.usage.spend.cost',
    ofe_usage_actual_time_period: '?@events.electric.usage.actual.timePeriod',
    ofe_usage_actual_kwh: '?@events.electric.usage.actual.kwh',
    ofe_usage_actual_night_kwh: '?@events.electric.usage.actual.nightKwh',
};

export default {
    providers: {
        segment: {
            type: 'track',
            name: 'fe_energy_questions_submitted',
            props: {
                ...segmentProps,
                ...props,
            },
        },
    },
};
